/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface FaqControllerGetPdfV1$Params {
  id: number;
  sprache: string;
}

export function faqControllerGetPdfV1(http: HttpClient, rootUrl: string, params: FaqControllerGetPdfV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, faqControllerGetPdfV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('sprache', params.sprache, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

faqControllerGetPdfV1.PATH = '/v1/faq/{id}/pdf/{sprache}';
